// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__Cncl-","requiredAsterisk":"Info_requiredAsterisk__1wEa6"};